import React from "react";

export const SendIcon = ({ height = "20", width = "20", ...props }) => (
    <svg width={`${width}px`} height={`${height}px  `} viewBox="0 0 24 24" strokeWidth="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color="#ffffff" {...props}>
        <path d="M22 12L3 20L6.5625 12L3 4L22 12Z" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M6.5 12L22 12" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
)